import { makeStyles } from "@material-ui/core";

const flexStyles = makeStyles((theme) => ({
  flexContainer: {
    display: "flex",
    flexWrap: "wrap",
    margin: "-10px",
  },
  itemSM: {
    width: "calc(25% - 20px)",
    margin: "10px",
  },
  itemSMD: {
    width: "calc(33.3% - 20px)",
    margin: "10px",
  },
  itemMD: {
    width: "calc(50% - 20px)",
    margin: "10px",
  },
  item: {
    width: "calc(100% - 20px)",
    margin: "10px",
  },
  item6x: {
    width: "calc(60% - 20px)",
    margin: "10px",
  },
  item4x: {
    width: "calc(40% - 20px)",
    margin: "10px",
  },
  item2x: {
    width: "calc(20% - 20px)",
    margin: "10px",
  },
  item2xFiller: {
    width: "calc(26.6% - 20px)",
    margin: "10px",
  },
  item7x: {
    width: "calc(70% - 20px)",
    margin: "10px",
  },
  item8x: {
    width: "calc(80% - 20px)",
    margin: "10px",
  },
  item3x: {
    width: "calc(30% - 20px)",
    margin: "10px",
  },
  item7xf: {
    width: "calc(70% - 0px)",
  },
  item3xf: {
    width: "calc(30% - 0px)",
  },
  itemCustom: {
    width: "calc(18% - 20px)",
    margin: "10px",
  },
  itemCustomMd: {
    width: "calc(15% - 20px)",
    margin: "10px",
  },
  itemCustomMd2: {
    width: "calc(85% - 20px)",
    margin: "10px",
  },
  itemCustomSm: {
    width: "calc(10% - 20px)",
    margin: "10px",
  },
  input: {
    width: "100%",
  },

  // Flex
  flex: {
    display: "flex",
  },
  flexGap: {
    display: "flex",
    gap: 10,
  },
  flexCenterGap: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  flexContentCenter: {
    display: "flex",
    justifyContent: "center",
  },
  flexCenterBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  flexCenterBetweenGap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
  },
  flexAlignEnd: {
    display: "flex",
    alignItems: "flex-end",
    gap: 4,
  },
  flexCenterEnd: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  centerGapEnd: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    justifyContent: "flex-end",
  },
  alignCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  // Form Actions
  actionWrap: {
    display: "flex",
    justifyContent: "flex-end",
    position: "sticky",
    bottom: 10,
    width: "100%",
    marginTop: 10,
    zIndex: 40,
    backgroundColor: "#fff",
    margin: "0px 10px",
    borderRadius: 4,
    ...theme.borderTop,
    boxShadow: `0 7px 30px -10px rgba(150,170,180,0.5)`,
    padding: "14px",
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  marginNone: {
    marginLeft: "0px",
    marginRight: "0px",
  },

  // Layout
  layout1L: {
    width: "calc(60% - 20px)",
    margin: "10px",
  },
  layout1S: {
    width: "calc(40% - 20px)",
    margin: "10px",
  },

  //
  flexSingle: {
    display: "flex",
    width: "100%",
    "&:not(:last-child)": {
      marginBottom: 8,
    },
  },
  singleL: {
    width: "60%",
  },
  singleS: {
    width: "40%",
  },
}));

export default flexStyles;
